module.exports = __webpack_public_path__ + "static/media/ACHIOTE_B_2.aed5f286.png";